import React from "react";
import OrganizationSubscription from '../admin/OrganizationView/OrganizationSubscription';
import Layout from "../common/Layout";
import styled from "styled-components";



const SingleClientSubscription = ({isAuthenticated}) => {

  return (
    <Layout navType="client">
      <StyledDashboardPage >
      <OrganizationSubscription isAuthenticated={isAuthenticated}/>
       
      </StyledDashboardPage>
    </Layout>
  );
};

const StyledDashboardPage = styled.div`

`;

export default SingleClientSubscription;
